// TODO: setup in CloudFront so we can use relative url

const baseUrl = window.location.origin + "/";
export default {
  baseUrl
};
